var $07a8d3b903fa886f$exports = {};
$07a8d3b903fa886f$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "placeholder": `\u{9009}\u{62E9}...`
};


export {$07a8d3b903fa886f$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
